import { META_ALLOW_ANONYMOUS, META_LAYOUT } from "@core/constants";
import { ETAB_LAYOUTS, ETAB_ROUTES } from "@etab/config";
import { smartRedirectProcess } from "./smart-redirect.process";

import LoadingPage from "./Loading.page.vue";

export default function () {
  return [
    {
      // loading page is the first page to show even before the app is up
      // its purpose is to show something to the user after splash screen
      // and redirect to the startup routing process
      path: ETAB_ROUTES.loading.path,
      name: ETAB_ROUTES.loading.name,
      component: LoadingPage,
      meta: { [META_ALLOW_ANONYMOUS]: true, [META_LAYOUT]: ETAB_LAYOUTS.startup },
    },
    {
      // startup routing page is common for both anonymous and logged-in users
      // its purpose is to redirect to the right page (auth or app home)
      path: ETAB_ROUTES.smartRedirect.path,
      name: ETAB_ROUTES.smartRedirect.name,
      meta: { [META_ALLOW_ANONYMOUS]: true },
      beforeEnter: smartRedirectProcess,
    },
  ];
}
